export const refs = {
  body: document.body,

  // BURGER MENU
  burger: document.querySelector('.burger-container'),
  burgerBtn: document.querySelector('.burger-btn'),
  burgerBtnClose: document.querySelector('.btn-close'),
  burgerMenuBtn: document.querySelectorAll('.button-menu'),
  burgerMenuLink: document.querySelectorAll('.burger-menu-link'),
  feedbackList: document.querySelector('.js-feedback-list'),

  // ORDER MODAL
  orderBackdrop: document.querySelector('[data-order-backdrop]'),
  orderModal: document.querySelector('[data-order-modal]'),
  orderCloseBtn: document.querySelector('[data-order-close]'),
  orderForm: document.querySelector('[data-order-form]'),
  dessertIdInput: document.querySelector('[name="dessertId"]'),
  submitBtn: document.querySelector('.order-submit-btn'),

  // PRODUCT MODAL
  productBackdrop: document.querySelector('[data-product-backdrop]'),
  productModal: document.querySelector('[data-product-modal]'),
  productCloseBtn: document.querySelector('[data-product-close]'),

  // BUTTONS
  orderOpenBtns: document.querySelectorAll('[data-order-open]'),
  wrapper: document.querySelector('.about-us-list'),
  items: document.querySelectorAll('.about-us-item'),
  desertsList: document.querySelector('.desert-cards'),
  desertsCategories: document.querySelector('.desert-categories'),
  desertsListPopular: document.querySelector('#popular-list'),
  desertsCategoriesSelect: document.querySelector('.desert-categories-select'),
  desertsEmpty: document.querySelector('.desert-empty'),
  desertsLoadMore: document.querySelector('.desert-load-more'),
  popularList: document.querySelector('.swiper-wrapper'),
};
